import { Injectable, Injector } from '@angular/core';
import { InjectableByKey } from '@common-modules/shared/injectable-by-key/injectable-by-key.decorator';
import { NotificationDto } from '../../shared/model/notifications/notification.dto';
import { PagedResultDto } from '../../shared/model/paged-result.dto';
import { GridODataService } from '../../shared/odata/grid-odata.service';

const endPoint = '/notification/elements';
@InjectableByKey({ key: 'NotificationRelatedService' })
@Injectable({ providedIn: 'root' })
export class NotificationRelatedService extends GridODataService<NotificationDto> {
  protected get url() {
    return `${this.apiUrl}${endPoint}`;
  }

  constructor(injector: Injector) {
    const apiEndpoint = `/api${endPoint}`;
    super(injector, apiEndpoint);
  }

  protected mapResponse(
    response: PagedResultDto<NotificationDto>
  ): PagedResultDto<NotificationDto> {
    return response;
  }
}
